import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/index.css";
import "./assets/tailwind.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import { domain, apiClient } from "@/api/api-client";

window.domain = domain;
window.apiClient = apiClient;

createApp(App).use(store).use(router).use(ElementPlus).mount("#app");
